import { calculatePositions, calculateCaptainPoints } from '../utils/positions';
import { Match, Player, PlayerPoints, PlayerResult, TotalsPoints } from '../../database.schema';
import { AWAITING_SCORES } from '../app/constants';

export const calculateTotals = (t1Players: Array<Player>, t2Players: Array<Player>, matches: Array<Match>) => {
  const t1PlayerTotals: Array<PlayerPoints> = t1Players.map((player: Player) => ({
    player,
    points: 0,
    average: 0,
    won: 0,
    lost: 0,
    halved: 0,
    captainPoints: 0,
    position: 0,
    roundsPlayed: 0,
    nearestThePin: 0,
    nearestThePinIn2: 0,
    longestDrive: 0,
  }));
  const t2PlayerTotals: Array<PlayerPoints> = t2Players.map((player: Player) => ({
    player,
    points: 0,
    average: 0,
    won: 0,
    lost: 0,
    halved: 0,
    captainPoints: 0,
    position: 0,
    roundsPlayed: 0,
    nearestThePin: 0,
    nearestThePinIn2: 0,
    longestDrive: 0,
  }));
  const teamResult: TotalsPoints = {
    team1Points: 0,
    team2Points: 0,
    team1Individual: t1PlayerTotals,
    team2Individual: t2PlayerTotals,
  };
  const matchHasScores = matches.every((match: Match) => match.status !== AWAITING_SCORES);
  if (matchHasScores) {
    matches.forEach((match: Match) => {
      teamResult.team1Points += match.team1.points;
      teamResult.team2Points += match.team2.points;
      match.team1.players.forEach((player: PlayerResult, index: number) => {
        const t1Player = teamResult.team1Individual.find((playerTotals: PlayerPoints) => playerTotals.player.id === player.playerId);
        if (t1Player) {
          t1Player.points += match.team1.players[index].points;
          t1Player.won += match.team1.points === 1 ? 1 : 0;
          t1Player.lost += match.team1.points === 0 ? 1 : 0;
          t1Player.halved += match.team1.points === 0.5 ? 1 : 0;
          const matchesPlayed = t1Player.won + t1Player.lost + t1Player.halved;
          t1Player.average = Math.round((t1Player.points / matchesPlayed) * 10) / 10;
          t1Player.captainPoints += match.team1.points * 6;
          t1Player.nearestThePin += player.nearestThePin;
          t1Player.nearestThePinIn2 += player.nearestThePinIn2;
          t1Player.longestDrive += player.longestDrive;
        }
      });
      match.team2.players.forEach((player, index) => {
        const t2Player = teamResult.team2Individual.find((playerTotals: PlayerPoints) => playerTotals.player.id === player.playerId);
        if (t2Player) {
          t2Player.points += match.team2.players[index].points;
          t2Player.won += match.team2.points === 1 ? 1 : 0;
          t2Player.lost += match.team2.points === 0 ? 1 : 0;
          t2Player.halved += match.team2.points === 0.5 ? 1 : 0;
          const matchesPlayed = t2Player.won + t2Player.lost + t2Player.halved;
          t2Player.average = Math.round((t2Player.points / matchesPlayed) * 10) / 10;
          t2Player.captainPoints += match.team2.points * 6;
          t2Player.nearestThePin += player.nearestThePin;
          t2Player.nearestThePinIn2 += player.nearestThePinIn2;
          t2Player.longestDrive += player.longestDrive;
        }
      });
    });
    teamResult.captainsRace = calculateCaptainPoints([...teamResult.team1Individual, ...teamResult.team2Individual], t1Players.length + t2Players.length);
    teamResult.individual = calculatePositions([...teamResult.captainsRace], 'points');
  }
  return teamResult;
};
